import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-08372871"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "body-container"
};
const _hoisted_4 = {
  class: "notice-box"
};
const _hoisted_5 = {
  class: "link-list"
};
const _hoisted_6 = {
  class: "text"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  class: "classify-box"
};
const _hoisted_11 = ["onClick"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_13 = {
  key: 0,
  class: "news-list"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 0,
  class: "news-item"
};
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = {
  class: "news-info"
};
const _hoisted_18 = ["title"];
const _hoisted_19 = {
  class: "date"
};
const _hoisted_20 = {
  key: 1,
  class: "notice-item"
};
const _hoisted_21 = ["title"];
const _hoisted_22 = ["innerHTML"];

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "new-more"
}, "查看详情 >", -1));

const _hoisted_24 = {
  class: "date"
};
const _hoisted_25 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_CardHeader, {
    link: `/notice.html?name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_7, _hoisted_8]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_11);
  }), 128))], 2), $data.classifyList.length > 7 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !$data.hiddenMoreClass && 'hidden']),
    onClick: _cache[0] || (_cache[0] = $event => $data.hiddenMoreClass = !$data.hiddenMoreClass)
  }, [_createTextVNode(_toDisplayString($data.hiddenMoreClass ? '展开' : '收起') + " ", 1), _hoisted_12], 2)) : _createCommentVNode("", true)]), $data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $options.handleLookDetail(item)
    }, [item.news_cover_url ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("img", {
      src: item.news_cover_url,
      class: "news-cover",
      alt: item.news_name
    }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
      class: "news-title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_18), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'YYYY-MM-DD')), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", {
      class: "title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_21), _createElementVNode("p", {
      class: "new-intro text-overflow-two",
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_22), _hoisted_23, _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'YYYY-MM-DD')), 1)]))], 8, _hoisted_14);
  }), 128))])) : _createCommentVNode("", true), $data.newsList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])) : _createCommentVNode("", true)])])])])]);
}